import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiConfig } from '@osos/shared/api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
interface TranslatedKeyword {
  translation: string;
}
@Injectable({
  providedIn: 'root',
})
export class TranslationDataService {
  protected apiConfig = inject(ApiConfig);
  constructor(private http: HttpClient) {}

  translate(keyword: string, toLocale = 'en'): Observable<string> {
    const body = {
      keyword,
      language: toLocale,
    };
    return this.http
      .post(`${this.apiConfig.dataApiBaseUrl}/translate/keyword`, body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .pipe(
        map((res) =>
          (res as TranslatedKeyword).translation?.trim().replace(/[/./"]/g, ''),
        ),
      );
  }
}
